// extracted by mini-css-extract-plugin
export var compact = "_ou-2";
export var phoneFrame = "_ou-0";
export var phoneScreen = "_ou-1";